module.exports = __webpack_public_path__ + "static/media/plus.ba0f582e.svg";